import { PageEvent } from './../../../models/custom-table/custom-table.model';
import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
  ViewEncapsulation,
  Type,
  ComponentRef,
  ViewContainerRef,
  ComponentFactoryResolver,
  Injector
} from "@angular/core";
import { Router } from "@angular/router";

import moment from "moment";

import { from, Observable, of, Subject, Subscription } from "rxjs";
import { get } from "lodash";
import * as XLSX from "xlsx";
import { numToSSColumn } from "../../../shared/utils/excelUtils";
import { TranslateService } from "@ngx-translate/core";

import { MatTableDataSource } from "@angular/material/table";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatDialog } from "@angular/material/dialog";

import {
  TableConfig,
  FieldType,
  DefaultPage,
  TableEvent,
  ColumnHidden,
  ExportEvent,
  ExportFormat,
  AdvancedFilter,
  ColumnSorterInfo,
  CategoriesPropertiesPrefixes,
  FilterName,
  ExportLimit,
  CustomAction,
} from "../../../models/custom-table/custom-table.model";
import { SnackbarService } from "../../services/snackbar/snackbar.service";
import { SnackbarType } from "src/app/models/snackbar/snackbar.model";
import { MatCheckboxChange } from "@angular/material/checkbox";
import { DomSanitizer, SafeUrl } from "@angular/platform-browser";
import { map, concatMap, scan, last, finalize, take, takeUntil, tap } from 'rxjs/operators';
import { ManageFileService } from "../../services/manage-files/manage-files.service";
import { RolePermissionsService } from "../../services/role-permissions/role-permissions.service";
import { SelectionModel } from "@angular/cdk/collections";

import {
  animate,
  state,
  style,
  transition,
  trigger,
} from "@angular/animations";
import { select, Store } from "@ngrx/store";
import { getTimezone } from "src/app/store/reducers";
import { AlertDialogComponent } from "../dialogs/alert-dialog/alert-dialog.component";
import { SortEvent, FilterEvent } from '../../../models/custom-table/custom-table.model';
import { SearchEvent } from 'src/app/models/custom-table/custom-table.model';

@Component({
  selector: "app-custom-table",
  templateUrl: "./custom-table.component.html",
  styleUrls: ["./custom-table.component.scss"],
  encapsulation: ViewEncapsulation.None,
  animations: [
    trigger("detailExpand", [
      state(
        "collapsed",
        style({ height: "0px", minHeight: "0", visibility: "hidden" })
      ),
      state("expanded", style({ height: "*", visibility: "visible" })),
      transition("expanded <=> collapsed", animate("180ms ease-in-out")),
    ]),
  ],
})
export class CustomTableComponent implements OnInit, OnDestroy {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('detailHost', { read: ViewContainerRef }) detailHostVcr: ViewContainerRef;
  private detailComponentRef: ComponentRef<any> | null = null;

  @Input() permissionResource: string;

  @Input() tableTitle: string;
  @Input() set tableConfiguration(tableConfig: TableConfig[]) {
    this.tableConfig = tableConfig;
    this.setColumns();
  }
  @Input() columnSorterInfo: ColumnSorterInfo[];
  @Input() set loading(isLoading: boolean) {
    this.isLoading = isLoading;
  }
  @Input() set tableData(data: any[]) {
    this.setTable(data, this.tableConfig);
    this.setSearchTooltip(this.tableConfig);

    this.selectedIds.clear();

    if (this.preselectedIds?.length) {
      this.preselectedIds.forEach(id => this.selectedIds.add(id));
    }

    this.restoreSelectionForCurrentPage();
  }
  @Input() set excelData(excelData: any[]) {
    if(this.isExportingAll && excelData?.length > 0){
      this.exportPageResponse$.next(excelData);
    } else {
      this.exportExcel(excelData, this.selectedExportFormat);
      this._excelData = excelData;
    }
  }
  @Input() set newSelectedIds(ids: string[]) {
    this.selectedIds.clear();
    if (ids.length) {
      ids.forEach(id => {
        this.selectedIds.add(id);
      });
    }
    this.restoreSelectionForCurrentPage();
  }
  private _excelData: any[] = [];
  private isExportingAll: boolean = false;
  private exportPageResponse$ = new Subject<any[]>();
  private destroy$ = new Subject<void>();
  @Input() tableLength: number;
  @Input() formPath: string;
  @Input() creationFormPath: string;
  @Input() dialogComponent: any;
  @Input() dialogData: object;
  @Input() showHeader: boolean = true;
  @Input() canRefresh: boolean = true;
  @Input() canOpen: boolean = true;
  @Input() canCreate: boolean = true;
  @Input() canDuplicate: boolean = true;
  @Input() searchLocal: boolean = false;
  @Input() canGenerate: boolean = false;
  @Input() canAdvanceFilter: boolean = true;
  @Input() canDateFilter: boolean = false;
  @Input() canOptionsFilter: boolean = false;
  @Input() canDownload: boolean = true;
  @Input() canSelect: boolean = false;
  @Input() canSelectMultiple: boolean = false;
  @Input() canDelete: boolean = false;
  @Input() canEditWithDialog: boolean = false;

  private _canExpand = false;
  @Input() set canExpand(val: boolean) {
    if (this._canExpand === val) return;
    this._canExpand = val;
    if (!val) {
      this.expandedElement = null;
      this.clearDynamicDetail();
    }
  }
  get canExpand(): boolean { return this._canExpand; }

  private _expandMode: "hidden" | "custom" = "hidden";
  get expandMode(): "hidden" | "custom" { return this._expandMode; }

  @Input() dateFilterSelectedMode: string = "TODAY";
  @Input() dateFilterInitialLoad: boolean = false;
  @Input() optionsList: { code: string; description: string }[];
  @Input() optionField: string;
  @Input() searchFilter: boolean = true;
  @Input() pagination: boolean = true;
  @Input() pageSizeOptions: number[] = [10, 25, 50, 100];
  @Input() identifierField: string = 'code';
  @Input() preselectedIds: string[] = [];
  @Input() hasStatusFilter: boolean = false;
  @Input() detailComponent: Type<any>;
  @Input() detailComponentInputs: { [key: string]: any };
  @Input() customAction: CustomAction | null = null;

  @Output()
  public getTableData: EventEmitter<TableEvent> =
    new EventEmitter<TableEvent>();
  @Output()
  public getExportData: EventEmitter<ExportEvent> =
    new EventEmitter<ExportEvent>();
  @Output()
  public saveTableConfig: EventEmitter<ColumnSorterInfo[]> = new EventEmitter<
    ColumnSorterInfo[]
  >();
  @Output()
  public openRowData: EventEmitter<string> = new EventEmitter<string>();
  @Output()
  public deleteRowData: EventEmitter<string> = new EventEmitter<string>();
  @Output() 
  public editRow: EventEmitter<any> = new EventEmitter<any>();
  @Output()
  public downloadRowData: EventEmitter<string> = new EventEmitter<string>();
  @Output() public getSearchTerms: EventEmitter<any> = new EventEmitter<any>();
  @Output() public getPage: EventEmitter<any> = new EventEmitter<any>();
  @Output() public getAdvancedFilter: EventEmitter<any> =
    new EventEmitter<any>();
  @Output() public getSort: EventEmitter<any> = new EventEmitter<any>();
  tableConfig: TableConfig[];
  @Output()
  dataSource: MatTableDataSource<any[]>;
  @Output() public selectedRowEmit: EventEmitter<Object> =
    new EventEmitter<Object>();
  @Output() rowSelectionMultipleEmit: EventEmitter<any[]> = new EventEmitter<
    any[]
  >();
  @Output() rowSelectionIdsEmit: EventEmitter<string[]> = new EventEmitter<string[]>();
  @Output() rowSelectionChange: EventEmitter<Object> = new EventEmitter<Object>();
  @Output() customActionClicked: EventEmitter<any> = new EventEmitter<any>();
  @Output() optionFilterChange = new EventEmitter<AdvancedFilter[]>();

  displayedColumns: string[];
  initDisplayedColumns: string[];
  allColumns: string[];
  allColumnNames: string[];
  columnsHidden: ColumnHidden[];
  pinnedColumns: string[];
  isLoading = false;
  count: number = 0;
  fieldType = FieldType;
  exportFormat = ExportFormat;
  exportLimit = ExportLimit;
  selectedExportFormat: ExportFormat;
  
  categoriesPropertiesPrefixes = CategoriesPropertiesPrefixes;
  expandedRowId: string | number | null = null;

  // Table checkboxes
  selection = new SelectionModel<any>(true, []);
  private selectedIds = new Set<string>();

  // Permissions
  public canWrite$: Observable<boolean> = of(true);

  searchTerms: string[] = [];
  searchTooltipText: string;

  advancedFilter: AdvancedFilter[] = [];
  dateFilter: AdvancedFilter[] = [];
  optionFilter: AdvancedFilter[] = [];

  defaultPageSize = DefaultPage.PAGE_SIZE;

  langSubscription: Subscription;

  public selectedRow: object = {};
  public multipleSelectedRows: any[] = [];

  thumbnailCache: Record<string, Observable<SafeUrl>> = {};

  public locale: string = localStorage.getItem("locale");

  expandedElement: any | null = null;

  datepickerMode: string;

  timezone: string;
	timezone$: Observable<string>;
	timezoneSubscription: Subscription;
	public dateTimeFormat: string;

  alertDialogComponent = AlertDialogComponent;

  constructor(
    public rolePermissionsService: RolePermissionsService,
    private store: Store,
    private router: Router,
    private translate: TranslateService,
    private snackbarService: SnackbarService,
    private dialog: MatDialog,
    private manageFileService: ManageFileService,
    private sanitizer: DomSanitizer,
    private cfr: ComponentFactoryResolver,
    private injector: Injector,
    private cdr: ChangeDetectorRef
  ) {
    this.timezone$ = this.store.pipe(select(getTimezone));
  }

  ngOnInit(): void {
    this.langSubscription = this.translate.onLangChange.subscribe(() => {
      this.setSearchTooltip(this.tableConfig);
    });

    if (this.permissionResource) {
      this.canWrite$ = this.rolePermissionsService.hasPermission(
        this.permissionResource,
        "WRITE"
      );
    }
 
    this.loadTimezoneChanges();  
  }

  loadTimezoneChanges() {
		this.timezoneSubscription = this.timezone$.subscribe((timezone) => {
			this.timezone = timezone;
		});
	}
  
  get renderedColumns(): string[] {
    return this.canExpand
      ? ["__expander", ...(this.displayedColumns || [])]
      : (this.displayedColumns || []);
  }

  toggleExpand(row: any): void {
    if (!this.canExpand) return;
    const id = row?.[this.identifierField];
    if (id == null) return;

    if (this.expandedRowId === id) {
      this.expandedRowId = null;
      this.clearDynamicDetail(); 
    } else {
      this.expandedRowId = id;
      if (this.detailComponent) {
        setTimeout(() => this.createDynamicDetail(row), 0);
      }
    }
  }

  isExpanded(row: any): boolean {
    return row?.[this.identifierField] === this.expandedRowId;
  }

  // Row predicate for the detail row
  isDetailRow = (_index: number, row: any) => this.isExpanded(row);

  private createDynamicDetail(row: any) {
    if (!this.detailComponent) return;

    // If user switched/collapsed quickly, ignore stale calls
    const id = row?.[this.identifierField];
    if (id == null || id !== this.expandedRowId) return;

    // If the host placeholder (#detailHost) isn’t in the DOM yet, just skip (no retries)
    if (!this.detailHostVcr) return;

    // Clear previous instance
    this.detailHostVcr.clear();
    this.detailComponentRef?.destroy();

    // Create the component
    const factory = this.cfr.resolveComponentFactory(this.detailComponent as Type<any>);
    const cmpRef = this.detailHostVcr.createComponent(factory, undefined, this.injector);

    // Pass ONLY the row input
    (cmpRef.instance as any).row = row;

    // Render now
    cmpRef.changeDetectorRef.detectChanges();

    this.detailComponentRef = cmpRef;
  }


private clearDynamicDetail() {
  if (this.detailHostVcr) this.detailHostVcr.clear();
  this.detailComponentRef?.destroy();
  this.detailComponentRef = null;
}

  public checkboxChanged(event: MatCheckboxChange, rowInfo: any): void {
    if (event.checked) {
      this.selectedRow = this.formatSelectedRowObject(rowInfo);
    } else {
      this.selectedRow = {};
    }

    this.selectedRowEmit.emit({ row: this.selectedRow });
  }

  public onRowSelectionChanged(selectedRowsInPage: any[], event?: MatCheckboxChange, rowInfo?: any): void {
    const currentPageIds = new Set(
      (this.dataSource?.data || []).map(r => r[this.identifierField])
    );

    currentPageIds.forEach(id => {
      const stillSelected = selectedRowsInPage.some(r => r[this.identifierField] === id);
      if (!stillSelected && this.selectedIds.has(id)) {
        this.selectedIds.delete(id);
      }
    });

    selectedRowsInPage.forEach(r => this.selectedIds.add(r[this.identifierField]));
    this.multipleSelectedRows = this.buildSelectedRowsArray();

    this.rowSelectionMultipleEmit.emit(this.multipleSelectedRows);
    this.rowSelectionIdsEmit.emit(Array.from(this.selectedIds));

    if(event) {
      const changedRow = {
        ...this.formatSelectedRowObject(rowInfo),
        checked: event.checked,
      };
      this.rowSelectionChange.emit(changedRow);
    }
  }

    private buildSelectedRowsArray(): any[] {
    return this.selection.selected.slice();
  }

  private restoreSelectionForCurrentPage(): void {
    if (!this.canSelectMultiple || !this.dataSource?.data?.length) return;

    this.selection.clear();

    this.dataSource.data.forEach(row => {
      const id = row[this.identifierField];
      if (this.selectedIds.has(id)) {
        this.selection.select(row);
      }
    });

    this.onRowSelectionChanged(this.selection.selected);
  }

  private formatSelectedRowObject(flatObject: any): any {
    const nestedObject = {};
  
    Object.keys(flatObject).forEach(key => {
      const keys = key.split('.');
      keys.reduce((acc, part, index) => {
        if (index === keys.length - 1) {
        const value = flatObject[key];
        acc[part] = (value && typeof value === 'object')
          ? { ...value }
          : value;
        } else {
          acc[part] = acc[part] || {};
        }
        return acc[part];
      }, nestedObject);
    });
  
    return nestedObject;
  }

  ngAfterViewChecked() {
    this.cdr.detectChanges();
  }

  setColumns() {
    this.allColumns = this.setDisplayedColumns(this.tableConfig);
    this.allColumnNames = this.setDisplayedColumnNames(this.tableConfig);
    this.columnsHidden = this.setDisplayedColumnsHidden(this.tableConfig);
    this.initDisplayedColumns = this.setDisplayedColumns(this.tableConfig);
  }

  setTable(data: any[], tableConfig: TableConfig[]) {
    this.dataSource = new MatTableDataSource<any[]>(
      this.setDataSource(data, tableConfig)
    );
    this.displayedColumns =
      this.displayedColumns || this.setDisplayedColumns(tableConfig);
  }

  setDataSource(data: any, tableConfig: TableConfig[]) {
    if (!data) {
      return;
    }

    return data.map((dataEl: any) => {
      let treatedElement = {
        disableOptions: dataEl.disableOptions,
        disableDelete: dataEl.disableDelete,
        disableCustomAction: dataEl.disableCustomAction,
      };
      tableConfig.forEach(({ field }) => {
        treatedElement = {
          ...dataEl,
          ...treatedElement,
          [field]: field.includes(".")
            ? this.setField(dataEl, field)
            : dataEl[field],
        };
      });
      return treatedElement;
    });
  }

  setDisplayedColumns(config: TableConfig[]): string[] {
    return config.filter(({ outOfView }) => !outOfView).map(({ field }) => field);
  }

  setDisplayedColumnNames(config: TableConfig[]): string[] {
    return config.map(({ header }) => header);
  }

  setDisplayedColumnsHidden(config: TableConfig[]): ColumnHidden[] {
    return config.map(({ header, hidden }) => {
      return {
        header,
        hidden: hidden ? hidden : false,
      };
    });
  }

  setSearchTooltip(tableConfig: TableConfig[]) {
    this.translate
      .get("SimpleFilter.HintTitle")
      .subscribe((translatedTitle) => {
        const searchTooltipHint = translatedTitle;
        const searchableFields = tableConfig
          .filter(({ searchable }) => searchable)
          .map(({ header }) => this.translate.instant(header));
        this.searchTooltipText = `${searchTooltipHint}\n${searchableFields.join(
          "\n"
        )}`;
      });
  }

  getMode(mode: string) {
    this.datepickerMode = mode;
  }

  getDates(dates: { startDate: string; endDate: string }) {
    const { startDate, endDate } = dates;
    const dateFilterCol = this.tableConfig.find((col) => col.dateFilter);

    const quickFiltersArr = [
      {
        column: dateFilterCol.field,
        fieldType: FieldType.DATE_TIME,
        operator: FilterName.GREATER_THAN_EQUAL,
        value: dateFilterCol.noOffset ? moment.utc(startDate).format("YYYY-MM-DDTHH:mm:ss") : startDate,
      },
      {
        column: dateFilterCol.field,
        fieldType: FieldType.DATE_TIME,
        operator: FilterName.LESS_THAN_EQUAL,
        value: dateFilterCol.noOffset ? moment.utc(endDate).format("YYYY-MM-DDTHH:mm:ss") : endDate,
      },
    ];

    if (this.dateFilter.length) {
      this.dateFilter = this.dateFilter.reduce((acc, cur, i) => {
        if (
          cur.column === dateFilterCol.field &&
          i < this.dateFilter.length - 1
        ) {
          return acc;
        }
        return startDate && endDate ? [...acc, ...quickFiltersArr] : acc;
      }, []);

      this.resetPaginator();
      this.getData();
      return;
    }

    this.dateFilter = [...quickFiltersArr];
    this.resetPaginator();
    this.getData();
  }

  getImageSource(value: string): Observable<SafeUrl | string> {
    if (!value || value.startsWith('http') || value.startsWith('data:image')) {
      return of(value);
    }
  
    if (!this.thumbnailCache[value]) {
      this.thumbnailCache[value] = this.manageFileService.getFileThumbnail(value).pipe(
        map(blob => {
          const url = URL.createObjectURL(blob);
          return this.sanitizer.bypassSecurityTrustUrl(url);
        })
      );
    }
  
    return this.thumbnailCache[value];
  }

  getWithOptionFilter(option: string) {
    const quickFiltersArr = [
      {
        column: this.optionField,
        fieldType: FieldType.STRING,
        operator: FilterName.EQUAL,
        value: option,
      },
    ];
    
    if (this.optionFilter.length) {
      this.optionFilter = this.optionFilter.reduce((acc, cur, i) => {
        if (
          cur.column === this.optionField &&
          i < this.optionFilter.length - 1
        ) {
          return acc;
        }
        return option ? [...acc, ...quickFiltersArr] : acc;
      }, []);
    } else {
      this.optionFilter = [...quickFiltersArr];
    }
    this.optionFilterChange.emit(this.optionFilter);
    
    this.resetPaginator();
    this.getData();
  }

  newRow() {
    if (this.dialogComponent) {
      this.openDialog(true);
      return;
    }

    if (this.creationFormPath) {
      this.router.navigate([`${this.creationFormPath}`]);
    } else {
      this.router.navigate([`${this.formPath}`]);
    }
  }

  setRouterLink(row: any) {
    if (this.dialogComponent) {
      return;
    }
  
    const idCol = this.tableConfig.find(col => col.identifier);
    const path = row.formPath || this.formPath;
  
    return [`/${path}`, row[idCol.field]];
  }

  openRow(row: any, dblClick?: boolean) {
    const idCol = this.tableConfig.find((col) => col.identifier);
    if (!idCol) {
      return;
    }
  
    if (this.dialogComponent) {
      this.openDialog(false, row);
      return;
    }

    const formPath = row.formPath || this.formPath;

    if (formPath) {
      if (dblClick) {
        this.router.navigate([formPath, row[idCol.field]]);
      } else {
        return [`/${formPath}`, row[idCol.field]];
      }
    } else {
      if (this.canSelect && dblClick) {
        this.selectedRow = this.formatSelectedRowObject(row);
        this.selectedRowEmit.emit({row: this.selectedRow, dblClick});
      } else {
        this.openRowData.emit(row[idCol.field]);
      }
    }
  }

  generateRow(row: any) {
    const idCol = this.tableConfig.find((col) => col.identifier);
    if (idCol) {
      this.openRowData.emit(row[idCol.field]);
    }
  }

  downloadRow(row: any) {
    const idCol = this.tableConfig.find((col) => col.identifier);
    if (idCol) {
      this.downloadRowData.emit(row[idCol.field]);
    }
  }

  duplicateRow(row: any) {
    if (this.dialogComponent) {
      this.openDialog(true, row);
      return;
    }

    const idCol = this.tableConfig.find((col) => col.identifier);
    if (idCol) {
      localStorage.setItem("duplicate", `${row[idCol.field]}`);
      this.router.navigate([this.formPath]);
    }
  }

  deleteRow(row: any) {
    const idCol = this.tableConfig.find((col) => col.identifier);
    if(idCol) {
      this.deleteRowData.emit(row[idCol.field]);
    }
  }

  openDialog(isCreate: boolean, rowData?: object) {
    this.dialog.open(this.dialogComponent, {
      autoFocus: false,
      data: {
        ...this.dialogData,
        rowData,
        isCreate,
      },
    }).afterClosed().subscribe((submitted: boolean) => {
      if (submitted) {
        this.getData();
      }
    });
    return;
  }

  openEditDialog(rowData: any) {
    this.editRow.emit(rowData);
  }
  
  getData() {
    if (!this.searchLocal) {
      const pageEvent = this.getPageEvent(this.paginator);
      const sortEvent = this.getSortEvent(this.sort);
      const searchEvent = this.getSearchEvent(this.searchTerms);
      const filterEvent = this.getFilterEvent(this.advancedFilter, this.dateFilter, this.optionFilter);
      if (pageEvent && this.canSelect) {
        this.selectedRow = {};
        this.selectedRowEmit.emit({ row: this.selectedRow });
      }
      this.getTableData.emit({
        pageEvent,
        sortEvent,
        searchEvent,
        filterEvent,
      });
    } else {
      const pageEvent = this.getPageEvent(this.paginator);
      const filterEvent = this.getFilterEvent(this.advancedFilter, this.dateFilter, this.optionFilter);
      const sortEvent = this.getSortEvent(this.sort);

      if (pageEvent) {
        if (this.canSelect) {
          this.selectedRow = {};
          this.selectedRowEmit.emit({ row: this.selectedRow });
        }
        this.getPage.emit(pageEvent);
      }
      if (filterEvent) {
        this.getAdvancedFilter.emit(filterEvent);
      }
      this.getSort.emit(sortEvent);
    }
    
    this.scrollToTop();
  }

  scrollToTop() {
    if (this.searchLocal) {
      return;
    }
    const top = document.getElementById('table');
    top.scrollIntoView();
  }

  onColumnSorted() {
    if (this.checkNoAdvancedFiltering(this.sort)) {
      return;
    }

    this.resetPaginator();
    this.getData();
  }

  checkNoAdvancedFiltering(sort: MatSort) {
    if (!sort) {
      return true;
    }
    
    const { active: sortedCol } = this.sort;
    const sortedColConfig = this.tableConfig.find(({ field }) => field === sortedCol);

    if (!sortedColConfig) {
      return true;
    }
    
    return sortedColConfig.noAdvanceFiltering;
  }

  setField(obj: object, field: string): any {
    return get(obj, field);
  }

  setArrayField(arrayElement: any[]): string {
    if (!arrayElement) {
      return;
    }
    let arrString = "";
    if (arrayElement.length === 1) {
      arrString = `${arrayElement[0].arrayDescription}`;
    } else {
      arrString = `${this.translate.instant("CustomGrid.multiValues")} (${arrayElement.length})`;
    }
    return arrString;
  }

  setObjectField(objectElement: object): string {
    if (!objectElement) {
      return;
    }
    let objString = "";
    if (Object.entries(objectElement).length === 1) {
      objString = `${Object.keys(objectElement)[0]}: ${Object.values(objectElement)[0]}`;
    } else {
      objString = `${this.translate.instant("CustomGrid.multiValues")} (${Object.entries(objectElement).length})`;
    }
    return objString;
  }

  checkObjLength(objectElement: object): boolean {
    return Object.entries(objectElement).length > 1;
  }

  checkPinnedColumns(field: string): boolean {
    if (!this.pinnedColumns || !this.pinnedColumns.length) {
      return false;
    }

    return !!this.pinnedColumns.find((pinColId) => pinColId === field);
  }

  onSearchChanged(searchTerms: string[]) {
    if (!this.searchLocal) {
      this.searchTerms = [...searchTerms];
      this.resetPaginator();
      this.getData();
    } else {
      const searchEvent = this.getSearchEvent(searchTerms);
      this.getSearchTerms.emit(searchEvent);
    }
  }

  resetPaginator() {
    if (!this.paginator) {
      return;
    }
    this.paginator.pageIndex = 0;
  }

  getPageEvent(paginator: MatPaginator) {
    return {
      pageIndex: paginator?.pageIndex || DefaultPage.PAGE_INDEX,
      pageSize: paginator?.pageSize || DefaultPage.PAGE_SIZE,
    };
  }

  getSortEvent(sort: MatSort) {
    if (this.checkNoAdvancedFiltering(sort)) {
      return;
    }

    return sort?.active && sort?.direction
      ? { active: sort.active, direction: sort.direction }
      : undefined;
  }

  getSearchEvent(searchTerms: string[]) {
    return searchTerms.length
      ? {
          searchTerms: [...searchTerms],
          filterConfig: this.tableConfig.filter(({ searchable }) => searchable),
        }
      : undefined;
  }

  getFilterEvent(advancedFilter: AdvancedFilter[], dateFilter: AdvancedFilter[], optionFilter: AdvancedFilter[]) {
    const advancedFiltersWithDateFilters = [...advancedFilter, ...dateFilter, ...optionFilter]

    return advancedFiltersWithDateFilters.length
      ? { advancedFilter: advancedFiltersWithDateFilters }
      : undefined;
  }

  getExcelData(exportFormat: ExportFormat, exportLimit: ExportLimit) {
    if (!this.dataSource.data.length) {
      this.snackbarService.show({
        message: this.translate.instant("Grid.generateExcelNoData"),
        type: SnackbarType.ERROR,
      });
      return;
    }

    this.requestExportConfirmation(
      exportLimit === ExportLimit.CURRENT,
    ).subscribe((confirmed) => {
      if (confirmed) {
        this.snackbarService.show({
          message: this.translate.instant("Grid.generateExcel"),
          type: SnackbarType.INFO,
        });

        this.selectedExportFormat = exportFormat;
        const sortEvent = this.getSortEvent(this.sort);
        const searchEvent = this.getSearchEvent(this.searchTerms);
        const filterEvent = this.getFilterEvent(
          this.advancedFilter,
          this.dateFilter,
          this.optionFilter,
        );

        if (exportLimit === ExportLimit.CURRENT) {
          const pageEvent = this.getPageEvent(this.paginator);
          this.getExportData.emit({ pageEvent, sortEvent, searchEvent, filterEvent });
          return;
        }

      this.isExportingAll = true;
      const totalRecords = this.paginator.length;

      this.fetchAllPagesSequentially(totalRecords, sortEvent, searchEvent, filterEvent)
        .pipe(
          finalize(() => (this.isExportingAll = false)),
          takeUntil(this.destroy$)
        )
        .subscribe({
          next: (allRecords) => this.exportExcel(allRecords, exportFormat),
          error: () => {
            this.snackbarService.show({
              message: this.translate.instant("Grid.generateExcelError"),
              type: SnackbarType.ERROR,
            });
          },
        });
      }
    });
  }

  fetchPage(
    pageIndex: number,
    pageSize: number,
    totalRecords: number,
    sortEvent: SortEvent,
    searchEvent: SearchEvent,
    filterEvent: FilterEvent
  ): Observable<any[]>{
    const pageEvent: PageEvent = { pageIndex, pageSize, length: totalRecords};
    this.getExportData.emit({ pageEvent, sortEvent, searchEvent, filterEvent });
    return this.exportPageResponse$.pipe(take(1))
  }

  fetchAllPagesSequentially(
    totalRecords: number,
    sortEvent: SortEvent,
    searchEvent: SearchEvent,
    filterEvent: FilterEvent,
    pageSize: number = 5000
  ) : Observable<any[]>{
    const totalPages = Math.ceil(totalRecords / pageSize);
    const pageIndexes = Array.from({length: totalPages}, (_, i) => i);

    return from(pageIndexes).pipe(
        concatMap((pageIndex) =>{
          return this.fetchPage(pageIndex, pageSize, totalRecords, sortEvent, searchEvent, filterEvent)
        }),
        scan((acc: any[], pageData: any[]) => {
          const accumulated = [...acc, ...pageData];
          return accumulated;
        }, []),
        last()
      );
  }

  requestExportConfirmation(skipDialog: boolean): Observable<boolean> {
    if (skipDialog) {
      return of(true);
    }

    return this.dialog
      .open(this.alertDialogComponent, {
        autoFocus: false,
        data: {
          message: this.translate.instant("CustomGrid.confirmExportAllRecordsMessage"),
          buttonText: {
            ok: this.translate.instant("CustomGrid.dialogOk"),
            cancel: this.translate.instant("CustomGrid.dialogCancel"),
          },
        },
      })
      .afterClosed();
  }

  exportExcel(excelData: any[], exportFormat: ExportFormat) {
    if (!excelData) {
      return;
    }

    const treatedExcel = this.treatExcelData(excelData, this.tableConfig);

    const now = new Date();

    let formattedDate = now.toISOString().replace(/:/g, '').replace('T', '_').split('.')[0];
    formattedDate = formattedDate.replace(/-/g, '_');

    const formattedTableTitle = this.tableTitle.replace(' ', '_');
    
    let excelName = `${formattedTableTitle}_${formattedDate}`;
    if (excelName.length > 120) {
      excelName = excelName.substring(0, 120);
    }

    let sheetName = formattedTableTitle;
    if (sheetName.length > 31) {
      sheetName = sheetName.substring(0, 31);
    }

    if (exportFormat === 'csv') {
      treatedExcel.forEach(row => {
        Object.keys(row).forEach(key => {
          const value = row[key];

          if (value instanceof Date) {
            row[key] = (this.timezone === "UTC" 
            ? moment.utc(value)
            : moment(value)).format("DD/MM/YYYY HH:mm:ss");
          }
        });
      });
    }

    const workSheet = XLSX.utils.json_to_sheet(treatedExcel, {
      dateNF: "DD/MM/YYYY HH:mm:ss",
      cellDates: true,
    });
    const [firstExcelRow] = treatedExcel;
    workSheet["!autofilter"] = {
      ref: "A1:" + numToSSColumn(Object.keys(firstExcelRow).length) + "1",
    };
    const workBook: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workBook, workSheet, sheetName);
    XLSX.writeFile(workBook, `${excelName}.${exportFormat}`, {
      cellDates: true,
    });
  }

  treatExcelData(excelData: any[], tableConfig: TableConfig[]) {
    const filteredSortedTableConfig =
      this.getFilteredAndSortedTableConfig(tableConfig);

    return excelData.map((excelRow) => {
      let treatedObj = {};
      filteredSortedTableConfig.forEach(({ header, field, fieldType, objectDescription }) => {
        //Special case for manual transaction card codes
        if (field === 'cardCodes[1].code' && excelRow.cardCodes) {
          treatedObj = this.cardCodesSpecialTreatment(header, excelRow, 0, treatedObj);
          return;
        } else if (field === 'cardCodes[2].code' && excelRow.cardCodes) {
          treatedObj = this.cardCodesSpecialTreatment(header, excelRow, 1, treatedObj);
          return;
        }
        //Special case for manual transaction prompts
        if (field === 'promptsData[0].prompts' && excelRow.promptsData) {
          treatedObj = this.promptsSpecialTreatment(header, excelRow, 0, treatedObj);
          return;
        } else if (field === 'promptsData[1].prompts' && excelRow.promptsData) {
          treatedObj = this.promptsSpecialTreatment(header, excelRow, 1, treatedObj);
          return;
        }
        //Special case for transaction prompts
        if (field === 'debitMovement.card[1].promptData' && excelRow.debitMovement.card) {
          treatedObj = this.promptsSpecialTreatment2(header, excelRow, 1, treatedObj);
          return;
        } else if (field === 'debitMovement.card[2].promptData' && excelRow.debitMovement.card) {
          treatedObj = this.promptsSpecialTreatment2(header, excelRow, 2, treatedObj);
          return;
        }
        const nestedField = this.setField(excelRow, field);
        treatedObj = {
          ...treatedObj,
          [this.translate.instant(header)]: this.handleExcelObject(
            fieldType,
            nestedField,
            objectDescription
          ),
        };
      });
      return treatedObj;
    });
  }

  cardCodesSpecialTreatment(header: string, excelRow: any, index: number, treatedObj: Object) {
    if (!excelRow.cardCodes[index]) {
      return treatedObj;
    }
    const nestedField = excelRow.cardCodes[index];
    return {
      ...treatedObj,
      [this.translate.instant(header)]: this.handleExcelObject(
        FieldType.STRING,
        nestedField
      ),
    };
  }

  promptsSpecialTreatment(header: string, excelRow: any, index: number, treatedObj: Object) {
    if (!excelRow.promptsData[index] || !excelRow.promptsData[index].prompts) {
      return treatedObj;
    }
    const nestedFieldObjs = excelRow.promptsData[index].prompts;
    const promptsFinalString = nestedFieldObjs.reduce((acc, cur) => {
      let prompts = '';
      for (const [key, value] of Object.entries(cur)) {
        if (prompts.length) {
          prompts = `${prompts} | ${key}: ${value}`;
        } else {
          prompts = `${key}: ${value}`;
        }
      }
      if (acc.length) {
        return `${acc} | ${prompts}`; 
      }
      return `${prompts}`;
    }, '');
    return {
      ...treatedObj,
      [this.translate.instant(header)]: this.handleExcelObject(
        FieldType.STRING,
        promptsFinalString
      ),
    };
  }

  promptsSpecialTreatment2(header: string, excelRow: any, index: number, treatedObj: Object) {
    if (!excelRow.debitMovement.card[index] || !excelRow.debitMovement.card[index].promptData) {
      return treatedObj;
    }
    const nestedFieldObj = excelRow.debitMovement.card[index].promptData;
    let promptsFinalString = '';
    for (const [key, value] of Object.entries(nestedFieldObj)) {
      if (promptsFinalString.length) {
        promptsFinalString = `${promptsFinalString} | ${key}: ${value}`;
      } else {
        promptsFinalString = `${key}: ${value}`;
      }
    }
    return {
      ...treatedObj,
      [this.translate.instant(header)]: this.handleExcelObject(
        FieldType.STRING,
        promptsFinalString
      ),
    };
  }

  handleExcelObject(fieldType: FieldType, nestedField: any, objectDescription = false) {
    switch (fieldType) {
      case FieldType.DATE:
        if (nestedField && Date.parse(nestedField)) {
          return new Date(nestedField).toLocaleDateString();
        } else return null;
      case FieldType.DATE_TIME:
        if (nestedField && Date.parse(nestedField)) {
          return new Date(nestedField);
        } else return null;
      case FieldType.BOOLEAN:
        if (nestedField) {
          return this.translate.instant("CustomGrid.True");
        } else {
          return this.translate.instant("CustomGrid.False");
        }
      case FieldType.ARRAY:
        if (!nestedField) {
          return null;
        }
        if (nestedField.length === 1) {
          return nestedField[0].arrayDescription;
        } else if (nestedField.length > 1) {
          return nestedField.reduce((acc, cur) => {
            if (acc.length) {
              return `${acc} | ${cur.arrayDescription}`; 
            }
            return `${cur.arrayDescription}`;
          }, '');
        }
      case FieldType.OBJECT_DESCRIPTION:
        if (nestedField) {
          return nestedField[this.locale];
        }
      default:
        return objectDescription ? nestedField[this.locale] : nestedField;
    }
  }

  getFilteredAndSortedTableConfig(tableConfig: TableConfig[]) {
    return tableConfig
      .filter(
        ({ field, fieldType }) =>
          fieldType !== FieldType.OPTIONS &&
          fieldType !== FieldType.PROGRESS &&
          this.displayedColumns.includes(field)
      )
      .sort(
        (a, b) =>
          this.displayedColumns.indexOf(a.field) -
          this.displayedColumns.indexOf(b.field)
      );
  }

  onTableConfigSaved(columnInfo: ColumnSorterInfo[]) {
    this.saveTableConfig.emit(columnInfo);
  }

  onAdvancedFilterChanged(advancedFilter: AdvancedFilter[]) {
    this.advancedFilter = advancedFilter;

    this.resetPaginator();
    this.getData();
  }

  checkAppliedFilter(column: TableConfig): boolean {
    const advancedFiltersWithDateFilters = [...this.advancedFilter, ...this.dateFilter, ...this.optionFilter];
    
    return advancedFiltersWithDateFilters.some((filter) => column.field === filter.column);
  }

  ngOnDestroy(): void {
    this.langSubscription.unsubscribe();
    this.clearDynamicDetail();
  }
}
